
export const programs = [
  { id: 'bee-certification', name: 'BEE Certification Program', description: 'Broad-Based Black Economic Empowerment certification training' },
  { id: 'digital-skills', name: 'Digital Skills Development', description: 'Essential digital literacy and technical skills' },
  { id: 'entrepreneurship', name: 'Entrepreneurship Training', description: 'Business development and entrepreneurial skills' }
];

export const cohorts = [
  { id: 'bee-2024-q1', name: 'BEE Q1 2024', programId: 'bee-certification', startDate: '2024-01-15', endDate: '2024-03-15', facilitatorId: '3' },
  { id: 'bee-2024-q2', name: 'BEE Q2 2024', programId: 'bee-certification', startDate: '2024-04-15', endDate: '2024-06-15', facilitatorId: '3' },
  { id: 'digital-2024-batch1', name: 'Digital Skills Batch 1', programId: 'digital-skills', startDate: '2024-02-01', endDate: '2024-05-01', facilitatorId: '9' },
  { id: 'entrepreneur-2024-a', name: 'Entrepreneurship 2024-A', programId: 'entrepreneurship', startDate: '2024-03-01', endDate: '2024-08-01', facilitatorId: '10' }
];

// Demo password for all mock accounts: Demo1234!
export const users = [
  {
    uid: '1',
    email: 'thabo.mthembu@example.co.za',
    password: 'Demo1234!',
    alternateEmails: ['thabo.personal@gmail.com'],
    role: 'learner',
    displayName: 'Demo Learner 1',
    enrolledDate: '2025-07-14',
    status: 'active',
    cohortId: 'bee-2024-q2',
    programId: 'bee-certification',
    documents: ['resume.pdf', 'id-copy.pdf', 'qualification-cert.pdf']
  },
  {
    uid: '2',
    email: 'nomsa.dlamini@example.co.za',
    password: 'Demo1234!',
    alternateEmails: [],
    role: 'learner',
    displayName: 'Demo Learner 2',
    enrolledDate: '2025-07-14',
    status: 'active',
    cohortId: 'bee-2024-q2',
    programId: 'bee-certification',
    documents: ['resume.pdf', 'id-copy.pdf']
  },
  {
    uid: '3',
    email: 'facilitator@npigovernancesolutions.com',
    password: 'Demo1234!',
    alternateEmails: ['sarah.j@personal.com'],
    role: 'facilitator',
    displayName: 'Demo Facilitator',
    enrolledDate: '2025-07-10',
    status: 'active',
    managedCohorts: ['bee-2024-q1', 'bee-2024-q2'],
    documents: []
  },
  {
    uid: '4',
    email: 'admin@npigovernancesolutions.com',
    password: 'Demo1234!',
    alternateEmails: [],
    role: 'admin',
    displayName: 'Demo Admin',
    enrolledDate: '2025-07-01',
    status: 'active',
    documents: []
  },
  {
    uid: '5',
    email: 'sipho.ngwenya@example.co.za',
    password: 'Demo1234!',
    alternateEmails: ['sipho.work@company.co.za'],
    role: 'learner',
    displayName: 'Demo Learner 4',
    enrolledDate: '2025-07-15',
    status: 'inactive',
    statusReason: 'family-commitments',
    statusReasonDetail: 'Temporarily unable to attend due to family obligations',
    cohortId: 'digital-2024-batch1',
    programId: 'digital-skills',
    documents: ['resume.pdf', 'id-copy.pdf', 'medical-certificate.pdf']
  },
  {
    uid: '6',
    email: 'fatima.hassan@example.co.za',
    password: 'Demo1234!',
    alternateEmails: [],
    role: 'learner',
    displayName: 'Demo Learner 5',
    enrolledDate: '2025-07-16',
    status: 'de-registered',
    statusReason: 'new-job',
    statusReasonDetail: 'Secured employment that conflicts with training schedule',
    cohortId: 'entrepreneur-2024-a',
    programId: 'entrepreneurship',
    documents: ['resume.pdf', 'id-copy.pdf', 'job-offer-letter.pdf']
  },
  {
    uid: '7',
    email: 'john.smith@example.co.za',
    password: 'Demo1234!',
    alternateEmails: [],
    role: 'learner',
    displayName: 'Demo Learner 3',
    enrolledDate: '2025-07-12',
    status: 'active',
    cohortId: 'bee-2024-q2',
    programId: 'bee-certification',
    documents: ['resume.pdf', 'id-copy.pdf', 'qualification-cert.pdf', 'portfolio.pdf']
  },
  {
    uid: '8',
    email: 'zanele.khumalo@example.co.za',
    password: 'Demo1234!',
    alternateEmails: ['zkhumalo@workmail.com'],
    role: 'learner',
    displayName: 'Demo Learner 6',
    enrolledDate: '2025-07-13',
    status: 'pregnant-leave',
    statusReason: 'pregnant',
    statusReasonDetail: 'On maternity leave, will resume after delivery',
    cohortId: 'digital-2024-batch1',
    programId: 'digital-skills',
    documents: ['resume.pdf', 'id-copy.pdf', 'medical-certificate.pdf']
  },
  {
    uid: '9',
    email: 'mike.facilitator@npigovernancesolutions.com',
    password: 'Demo1234!',
    alternateEmails: [],
    role: 'facilitator',
    displayName: 'Demo Facilitator 2',
    enrolledDate: '2024-01-15',
    status: 'active',
    managedCohorts: ['digital-2024-batch1'],
    documents: []
  },
  {
    uid: '10',
    email: 'lisa.facilitator@npigovernancesolutions.com',
    password: 'Demo1234!',
    alternateEmails: [],
    role: 'facilitator',
    displayName: 'Demo Facilitator 3',
    enrolledDate: '2024-02-01',
    status: 'active',
    managedCohorts: ['entrepreneur-2024-a'],
    documents: []
  },
  {
    uid: '11',
    email: 'qa@npigovernancesolutions.com',
    password: 'Demo1234!',
    alternateEmails: [],
    role: 'qa',
    displayName: 'Demo QA',
    enrolledDate: '2024-01-10',
    status: 'active',
    documents: []
  },
  {
    uid: '12',
    email: 'assessor@npigovernancesolutions.com',
    password: 'Demo1234!',
    alternateEmails: [],
    role: 'assessor',
    displayName: 'Demo Assessor',
    enrolledDate: '2024-01-10',
    status: 'active',
    documents: []
  }
];

export const recentlyDeletedUsers = [
  {
    uid: 'deleted_1',
    email: 'former.student@example.co.za',
    alternateEmails: [],
    role: 'learner',
    displayName: 'Former Student',
    enrolledDate: '2024-05-15',
    status: 'deleted',
    deletedDate: '2024-12-15',
    deletedBy: '4',
    deleteReason: 'Duplicate account',
    cohortId: 'bee-2024-q1',
    programId: 'bee-certification',
    documents: ['resume.pdf', 'id-copy.pdf']
  }
];

export const statusOptions = [
  { value: 'active', label: 'Active', description: 'Currently enrolled and participating' },
  { value: 'inactive', label: 'Inactive', description: 'Temporarily not participating' },
  { value: 'de-registered', label: 'De-registered', description: 'Formally withdrawn from program' },
  { value: 'pregnant-leave', label: 'Maternity Leave', description: 'On maternity/pregnancy leave' },
  { value: 'suspended', label: 'Suspended', description: 'Temporarily suspended from program' },
  { value: 'graduated', label: 'Graduated', description: 'Successfully completed program' }
];

export const statusReasons = [
  { value: 'family-commitments', label: 'Family Commitments', description: 'Unable to attend due to family obligations' },
  { value: 'pregnant', label: 'Pregnancy', description: 'On maternity leave or pregnancy-related absence' },
  { value: 'new-job', label: 'New Employment', description: 'Secured employment that conflicts with schedule' },
  { value: 'health-issues', label: 'Health Issues', description: 'Medical reasons preventing attendance' },
  { value: 'financial-constraints', label: 'Financial Constraints', description: 'Unable to continue due to financial reasons' },
  { value: 'relocated', label: 'Relocated', description: 'Moved to different location' },
  { value: 'academic-conflict', label: 'Academic Conflict', description: 'Conflict with other studies' },
  { value: 'personal-reasons', label: 'Personal Reasons', description: 'Other personal circumstances' }
];
